var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"illustration-image"},[_c('img',{staticClass:"illustration-image-main",attrs:{"src":require("@/assets/images-brand/paat_kolmnurk.png"),"aria-hidden":"true"}})])])
}]

export { render, staticRenderFns }